import { render } from "./BiensPage.vue?vue&type=template&id=0f298430"
import script from "./BiensPage.vue?vue&type=script&lang=js"
export * from "./BiensPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__